import React from 'react';
export const RecordCircle = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" fillRule="evenodd" />,
<path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" fillRule="evenodd" /></svg>
);
